interface FormattedDateProps {
    dateString: string;
    className?: string;
}

const FormattedDate: React.FC<FormattedDateProps> = ({ dateString, className }) => {
    const formatDate = (input: string): string => {
        try {
            const date = new Date(input);
            
            // Check if date is valid
            if (isNaN(date.getTime())) {
                return input; // Return original string if parsing fails
            }
            
            const day = date.getDate();
            
            // Indonesian month names
            const monthNames = [
                'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
                'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'
            ];
            
            const month = monthNames[date.getMonth()];
            const year = date.getFullYear();
            
            return `${day} ${month} ${year}`;
        } catch (error) {
            console.error("Error formatting date:", error);
            return input; // Return original string if parsing fails
        }
    };

    return <span className={className}>{formatDate(dateString)}</span>;
};
  
export default FormattedDate;